import { http } from 'utils'
import { findIndex } from 'lodash'
import Vue from 'vue'

// Note mutation imports.
import {
  SET_NOTES, ADD_NOTE, REMOVE_NOTE, SET_NOTE, UNPIN_ALL_NOTES
} from 'vx/mutations'

// Note state.
const state = {
  notes: []
}

// Note state getters.
const getters = {
  //
}

// Note actions.
const actions = {
  /**
   * Get notes for a booking.
   *
   * @return Promise
   */
  getBookingNotes ({ commit }, id) {
    return http.get(`booking/${id}/notes`)
      .then((response) => {
        commit(SET_NOTES, response.data)

        return response
      })
  },

  /**
   * Store notes a booking.
   *
   * @return Promise
   */
  storeBookingNote ({ commit }, { id, payload }) {
    return http.post(`booking/${id}/notes`, {
      text: payload.text,
      user_id: payload.user.id
    })
      .then((response) => {
        response.data.user = payload.user
        commit(ADD_NOTE, response.data)
        return response
      })
  },

  pinNote ({ commit }, { bookingId, noteId }) {
    return http.put(`booking/${bookingId}/note/${noteId}/pin`)
      .then((response) => {
        commit(UNPIN_ALL_NOTES)
        commit(SET_NOTE, response.data)

        return response
      })
  },

  /**
   * Remove a note.
   *
   * @return Promise
   */
  removeNote ({ commit }, { id, noteId }) {
    return http.delete(`booking/${id}/note/${noteId}`)
      .then((response) => {
        commit(REMOVE_NOTE, noteId)

        return response
      })
  }
}

// Note state mutations.
const mutations = {
  /**
   * Set notes
   */
  [SET_NOTES] (state, notes) {
    state.notes = notes
  },

  [SET_NOTE] (state, note) {
    const index = state.notes.findIndex(element => element.id === note.id)
    if (index !== -1) {
      state.notes.splice(index, 1, note)
    }
  },

  [UNPIN_ALL_NOTES] (state) {
    state.notes.forEach(note => {
      Vue.set(note, 'pinned', false)
    })
  },

  /**
  * Add new note
  */
  [ADD_NOTE] (state, note) {
    state.notes.unshift(note)
  },

  /**
   * Remove note
   */
  [REMOVE_NOTE] (state, id) {
    let index = findIndex(state.notes, note => note.id === id)

    state.notes.splice(index, 1)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
